/**
 * Downloads a file from a Blob object
 * @param blob Blob object to download
 * @param filename Target file name
 */
export function downloadFileFromBlob(blob: Blob, filename?: string) {
    const url = URL.createObjectURL(blob);
    downloadFileFromDataUrl(url, filename);
    URL.revokeObjectURL(url);
}
/**
 * Downloads a file from a string content
 * @param content String content to download
 * @param filename Target file name
 * @param type MIME type of the content
 */
export function downloadFileFromString(content: string, filename: string, type: string) {
    const blob = new Blob([content], { type });
    downloadFileFromBlob(blob, filename);
}

/**
 * Downloads a file from a data url
 * @param dataUrl Data url to download
 * @param filename Target file name
 */
export function downloadFileFromDataUrl(dataUrl: string, filename?: string) {
    const a = document.createElement('a');
    a.href = dataUrl;

    if (filename) {
        a.download = filename;
    }

    a.click();
}

/**
 * Converts a file to a data url
 * @param file File to get as data url
 * @returns Data url
 */
export function fileToDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
    });
}
